import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { Summary } from '@engloba-tech/englobity';
import { Loading } from 'shared';
import { useReadDefectiveTagsStepStyles } from './readDefectiveTagsStep.styles';

export function ReadDefectiveTagsStepSummary({ description, errors, isBusy }) {
  const classes = useReadDefectiveTagsStepStyles();
  return (
    <Grid container spacing={3} className={classes.root}>
      {errors?.message ? (
        <Grid xs={12} item className={classes.info}>
          <Summary severity={'error'} text={errors.message} detail={errors.detail} className={classes.summary} />
        </Grid>
      ) : (
        <Grid xs={12} item container className={classes.info}>
          <Info fontSize="large" className={classes.infoIcon} />
          <Typography variant="subtitle1" component="div" className={classes.title}>
            {description}
          </Typography>
          <Grid xs={12} item className={classes.loadingContainer}>
            <Loading className={classes.loading} />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

ReadDefectiveTagsStepSummary.propTypes = {
  description: PropTypes.string,
  errors: PropTypes.shape({
    message: PropTypes.string,
    detail: PropTypes.string
  }),
  isBusy: PropTypes.bool
};
